import { BUNDLE_VERSION, CDN, TELEMETRY_BUNDLE_VERSION } from "../../constants";

export type ScriptsProps = { withTelemetry?: boolean };

export function Scripts({ withTelemetry = false }: ScriptsProps) {
	const version = withTelemetry ? TELEMETRY_BUNDLE_VERSION : BUNDLE_VERSION;

	return (
		<>
			<script
				defer
				crossOrigin="anonymous"
				src={`${CDN}/nube-sdk-${version}.min.js`}
			/>
			<script
				defer
				crossOrigin="anonymous"
				src={`${CDN}/register-${version}.min.js`}
			/>
		</>
	);
}
